import { h, render, Component } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { appConfig } from '../app.config';


class TxrRequestTrialHsForm extends Component {
    state = {
        
    }
    componentDidMount() {
        // 1. Check if HubSpot script loaded globally
        if (window.hbspt) {
            this.initializeForm();
        } else {
            // 2. Fallback: If script isn't loaded yet, wait for it to load
            const script = document.querySelector('script[src*="hsforms.net"]');
            if (script) {
                script.addEventListener('load', () => this.initializeForm());
                this.cleanupLoadListener = () => script.removeEventListener('load', initForm);
            }
        }
    }
    componentWillUnmount() {
        // Remove the event listener to prevent memory leaks if the user leaves the page quickly
        if (this.cleanupLoadListener) {
            this.cleanupLoadListener();
        }
    }
    initializeForm() {
        const portalId = `${appConfig.hubspotV2PortalId}`;
        const formId = `${appConfig.hubspotV2FreeTrialRequestFormId}`;

        window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            region: 'na1',
            target: '.txr-request-trial-hs-form' 
        });
    }
    render() {
        return (
            <div class="txr-request-trial-hs-form">
                <script charset="utf-8" type="text/javascript" src="https://js.hsforms.net/forms/embed/v2.js" defer></script>
            </div>
            
            );
        }
}

export default TxrRequestTrialHsForm;
